// some information about the current user agent
export function browser() {
  const agent = window.navigator.userAgent;
  const android = /Android.*Mobile/.test(agent);
  const ios = /iPad|iPhone|iPod/.test(agent);
  const mobile = ios || android;
  const desktop = !mobile;
  return { android, desktop, ios, mobile };
}

// what platform are we on?
export function platform(): "android" | "desktop" | "ios" {
  const { ios, mobile } = browser();
  return mobile ? (ios ? "ios" : "android") : "desktop";
}
